<template>
  <section class="recipe-section">
    <h1 class="title"> {{ title }} </h1>

    <div class="section-container">

      <figure>
        <span class="label">Author: </span>
        <span>{{ author }}</span>
      </figure>

      <figure>
        <span class="label">Category: </span>
        <span>{{ category }}</span>
      </figure>

      <figure>
        <span class="label">Diet: </span>
        <span>{{ diet }}</span>
      </figure>

      <h1 class="title">Ingredients</h1>

      <div class="ingredients-container">
        <ul>
          <li
            v-for="(ingredient, index) in ingredients"
            :key="index">
            <section>
              <span class="quantity">{{ ingredient.quantity }}</span>

              <span class="measure">{{ ingredient.measurement }}</span>

              <span class="ingredient-name">{{ ingredient.name }}</span>
            </section>
          </li>
        </ul>
      </div>

      <figure class="directions-section">
        <span class="label">Directions: </span>
        <span>{{ directions }}</span>
      </figure>

      <figure>
        <span class="label">Notes: </span>
        <span>{{ notes }}</span>
      </figure>

    </div>
  </section>
</template>
<script>
import axios from 'axios';
import localStore from '@/storageInterface';
import { envConfig } from '@/appConfig.js';

const { urlBase } = envConfig;

export default {
  data() {
    return {
      title: '',
      author: '',
      category: '',
      diet: '',
      ingredients: [],
      directions: '',
      notes: '',
      id: '',
    };
  },
  async mounted() {
    const recipeId = this.$route.params.id;
    this.id = recipeId;
    const response = await axios.get(`${urlBase}/recipes/${recipeId}`, {
      headers: { Authorization: localStore.getUserToken() },
    });
    const recipe = response.data.response;
    const recipeFields = Object.keys(recipe);
    recipeFields.forEach((field) => {
      this[field] = recipe[field];
    });
  },
};
</script>
<style lang=scss>
  .recipe-section {
    margin-bottom: 5em;

    .title {
      color: #5495DB;
      margin-bottom: .5em;
      margin-top: 2em;
      font-weight: bold;
      text-align: center;
    }

    .route-link {
      text-align: center;
      margin-bottom: .5em;
    }

    .section-container {
      margin: 2em auto;
      width: 18em;
    }

    .label {
      font-weight: bold;
      font-style: italic;
      margin-right: .5em;
    }

    .ingredients-container {
      margin: 0 auto 1.5em ;
      width: 18em;
    }

    .ingredient-name {
      margin-left: 0.5em;
    }

    .quantity {
      margin-right: .2em;
    }

    .directions-section {
      margin-bottom: 1.5em;
    }

  }
</style>
